export default __webpack_public_path__ + "static/media/Matsal1.d9d0ca6e.jpeg";